"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _inline_svg = require("./inline_svg.utils");
var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));
var _excluded = ["fontsize", "themeColor"];
var AirLineSeatReclineExtra = function AirLineSeatReclineExtra(props) {
  var theme = _react.default.useContext(_styledComponents.ThemeContext);
  var fontsize = props.fontsize,
    themeColor = props.themeColor,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _parseStyles = (0, _inline_svg.parseStyles)({
      fontsize: fontsize,
      themeColor: themeColor
    }, theme),
    sizeStyles = _parseStyles.sizeStyles,
    colorStyles = _parseStyles.colorStyles;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M3.46153 3.19223C3.12478 3.19223 2.83547 3.07129 2.59359 2.82941C2.35171 2.58754 2.23077 2.29822 2.23077 1.96148C2.23077 1.62472 2.35171 1.33541 2.59359 1.09353C2.83547 0.851651 3.12478 0.730713 3.46153 0.730713C3.79828 0.730713 4.0876 0.851651 4.32948 1.09353C4.57135 1.33541 4.69229 1.62472 4.69229 1.96148C4.69229 2.29822 4.57135 2.58754 4.32948 2.82941C4.0876 3.07129 3.79828 3.19223 3.46153 3.19223ZM7.33334 11.9999H3.20003C2.86327 11.9999 2.55707 11.8854 2.28144 11.6563C2.0058 11.4272 1.83336 11.1443 1.76414 10.8076L0.346191 3.66658H1.36667L2.79487 10.7948C2.8077 10.8461 2.83868 10.8931 2.88783 10.9358C2.93698 10.9785 2.9872 10.9999 3.03849 10.9999H7.33334V11.9999ZM10.859 13.4614L9.04103 10.3332H4.31794C4.03419 10.3332 3.78996 10.2478 3.58526 10.0768C3.38057 9.9059 3.24703 9.68282 3.18463 9.40761L2.42566 5.7512C2.31626 5.25633 2.43057 4.82578 2.76859 4.45955C3.10663 4.0933 3.51026 3.91018 3.97949 3.91018C4.32991 3.91018 4.64957 4.0151 4.93846 4.22493C5.22734 4.43475 5.41195 4.72044 5.49229 5.08198L6.26409 8.6666H8.58461C8.78803 8.6666 8.97692 8.71916 9.15128 8.8243C9.32563 8.92942 9.46751 9.07343 9.57691 9.25635L11.7307 12.9614L10.859 13.4614Z",
    fill: "#B04459"
  }, colorStyles)));
};
AirLineSeatReclineExtra.propTypes = _inline_svg2.default.propTypes;
AirLineSeatReclineExtra.defaultProps = _inline_svg2.default.defaultProps;
var _default = AirLineSeatReclineExtra;
exports.default = _default;